import { WidgetContainer } from '@/components/analytics/WidgetContainer';
import { ProgressRing } from '@/components/analytics/charts/ProgressRing';
import type { ChallengingQuestion } from '@/types/analytics';
import styles from './MostChallenging.module.scss';

export interface MostChallengingProps {
  data: ChallengingQuestion[] | null;
  isLoading?: boolean;
  error?: Error | null;
  limit?: number;
}

export function MostChallenging({ data, isLoading, error, limit = 5 }: MostChallengingProps) {
  const isEmpty = !data || data.length === 0;

  const sortedData = data
    ? [...data].sort((a, b) => a.successRate - b.successRate).slice(0, limit)
    : [];

  return (
    <WidgetContainer
      title="Most Challenging Questions"
      description="Questions with lowest success rates"
      isLoading={isLoading}
      error={error}
      isEmpty={isEmpty}
      emptyMessage="Practice questions to identify challenges"
      size="large"
    >
      <div className={styles.mostChallenging}>
        {sortedData.map((q, index) => (
          <div key={q.questionId} className={styles.mostChallenging__item}>
            <div className={styles.mostChallenging__rank}>#{index + 1}</div>
            <ProgressRing
              value={q.successRate}
              max={100}
              size={60}
              thickness={6}
              color={q.successRate < 50 ? 'var(--error)' : 'var(--warning)'}
              showValue={false}
              animate={false}
            />
            <div className={styles.mostChallenging__info}>
              <div className={styles.mostChallenging__text}>{q.questionText}</div>
              <div className={styles.mostChallenging__stats}>
                {q.correctAttempts}/{q.totalAttempts} correct · {q.successRate.toFixed(0)}%
              </div>
            </div>
          </div>
        ))}
      </div>
    </WidgetContainer>
  );
}
